module.exports = __webpack_public_path__ + "img/rupee.5e269c39.svg";